import React, { useRef, useState } from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';
import SignatureCanvas from 'react-signature-canvas';
import { TranslationComponent } from '../../TranslationComponent';

interface SignatureModalProps {
  onSignature: (signature: string) => void;
}

export const SignatureModal: React.FC<SignatureModalProps> = ({ onSignature }) => {
  const canvas = useRef(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [signatureData, setSignatureData] = useState('');

  const handleModalOpen = () => setModalOpen(true);

  const handleModalClose = () => setModalOpen(false);

  const handleSignatureEnd = () => {
    if (canvas) {
      setSignatureData(canvas.current.toDataURL());
    }
  };

  const handleConfirm = () => {
    onSignature(signatureData);
    handleModalClose();
  };

  return (
    <Modal
      trigger={
        <Button icon type={'button'} onClick={handleModalOpen}>
          <Icon name="signup" />
        </Button>
      }
      open={modalOpen}
      onClose={handleModalClose}
      closeOnDimmerClick={false}
    >
      <Modal.Header>
        <TranslationComponent stringKey={'Firma'} />
      </Modal.Header>
      <Modal.Content>
        <SignatureCanvas
          ref={canvas}
          penColor="black"
          canvasProps={{ width: 800, height: 400, className: 'sigCanvas' }}
          onEnd={handleSignatureEnd}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleModalClose}>
          <TranslationComponent stringKey={'Cancel'} />
        </Button>
        <Button primary onClick={handleConfirm}>
          <TranslationComponent stringKey={'Confirm'} />
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
